/* eslint-disable max-lines -- one endpoint table for the departments API domain; declarations only */
import type {
  AddressForServiceWorkerContractListApiData,
  AddressForServiceWorkerContractListApiResponses,
  DinteroSessionProfileCreateApiData,
  DinteroSessionProfileCreateApiResponses,
  DinteroSessionProfileCreateDefaultApiData,
  DinteroSessionProfileCreateDefaultApiResponses,
  DinteroSessionProfileListApiData,
  DinteroSessionProfileListApiResponses,
  DinteroSessionProfileUpdateApiData,
  DinteroSessionProfileUpdateApiResponses,
  ServiceAreaCreateApiData,
  ServiceAreaCreateApiResponses,
  ServiceAreaDeleteApiData,
  ServiceAreaDeleteApiResponses,
  ServiceAreaGetApiData,
  ServiceAreaGetApiResponses,
  ServiceAreaListApiData,
  ServiceAreaListApiResponses,
  ServiceAreaListForDeliveryMapApiData,
  ServiceAreaListForDeliveryMapApiResponses,
  ServiceAreaMinimalListApiData,
  ServiceAreaMinimalListApiResponses,
  ServiceAreaPatchApiData,
  ServiceAreaPatchApiResponses,
  ServiceDepartmentAreaListApiData,
  ServiceDepartmentAreaListApiResponses,
  ServiceDepartmentAreaSuggestionsApiData,
  ServiceDepartmentAreaSuggestionsApiResponses,
  ServiceDepartmentCreateApiData,
  ServiceDepartmentCreateApiResponses,
  ServiceDepartmentDeleteApiData,
  ServiceDepartmentDeleteApiResponses,
  ServiceDepartmentDeliveryAreaGetApiData,
  ServiceDepartmentDeliveryAreaGetApiResponses,
  ServiceDepartmentDeliveryAreasPatchApiData,
  ServiceDepartmentDeliveryAreasPatchApiResponses,
  ServiceDepartmentFilterOptionsGetApiData,
  ServiceDepartmentFilterOptionsGetApiResponses,
  ServiceDepartmentFromBookingParamsGetApiData,
  ServiceDepartmentFromBookingParamsGetApiResponses,
  ServiceDepartmentGetApiData,
  ServiceDepartmentGetApiResponses,
  ServiceDepartmentGetStartedApiData,
  ServiceDepartmentGetStartedApiResponses,
  ServiceDepartmentGroupAddMembersApiData,
  ServiceDepartmentGroupAddMembersApiResponses,
  ServiceDepartmentGroupCreateApiData,
  ServiceDepartmentGroupCreateApiResponses,
  ServiceDepartmentGroupDeleteApiData,
  ServiceDepartmentGroupDeleteApiResponses,
  ServiceDepartmentGroupGetApiData,
  ServiceDepartmentGroupGetApiResponses,
  ServiceDepartmentGroupListByServiceOrganizationApiData,
  ServiceDepartmentGroupListByServiceOrganizationApiResponses,
  ServiceDepartmentGroupMemberListApiData,
  ServiceDepartmentGroupMemberListApiResponses,
  ServiceDepartmentGroupPatchApiData,
  ServiceDepartmentGroupPatchApiResponses,
  ServiceDepartmentListApiData,
  ServiceDepartmentListApiResponses,
  ServiceDepartmentListCapacityOverviewApiData,
  ServiceDepartmentListCapacityOverviewApiResponses,
  ServiceDepartmentMemberListApiData,
  ServiceDepartmentMemberListApiResponses,
  ServiceDepartmentMinimalListApiData,
  ServiceDepartmentMinimalListApiResponses,
  ServiceDepartmentPatchApiData,
  ServiceDepartmentPatchApiResponses,
  ServiceDepartmentPaymentDefaultsApiData,
  ServiceDepartmentPaymentDefaultsApiResponses,
  ServiceDepartmentUpdateCapacityApiData,
  ServiceDepartmentUpdateCapacityApiResponses,
  ServiceOrganizationAdapterListApiData,
  ServiceOrganizationAdapterListApiResponses,
  ServiceOrganizationAllowedBrandsListApiData,
  ServiceOrganizationAllowedBrandsListApiResponses,
  ServiceOrganizationCreateApiData,
  ServiceOrganizationCreateApiResponses,
  ServiceOrganizationDeleteApiData,
  ServiceOrganizationDeleteApiResponses,
  ServiceOrganizationGetApiData,
  ServiceOrganizationGetApiResponses,
  ServiceOrganizationListApiData,
  ServiceOrganizationListApiResponses,
  ServiceOrganizationLocationGetApiData,
  ServiceOrganizationLocationGetApiResponses,
  ServiceOrganizationStripeAccountStatusApiData,
  ServiceOrganizationStripeAccountStatusApiResponses,
  ServiceOrganizationStripeOnboardingLinkApiData,
  ServiceOrganizationStripeOnboardingLinkApiResponses,
  ServiceOrganizationUpdateApiData,
  ServiceOrganizationUpdateApiResponses,
  UserServiceDepartmentAccessDepartmentsListApiData,
  UserServiceDepartmentAccessDepartmentsListApiResponses,
  UserServiceDepartmentAccessGroupsListApiData,
  UserServiceDepartmentAccessGroupsListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getServiceDepartmentUrls = {
  getPaginatedServiceDepartments: dataEndpoint<ServiceDepartmentListApiData, ServiceDepartmentListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-departments/', queryParams)
  }),
  getPaginatedMinimalServiceDepartments: dataEndpoint<
    ServiceDepartmentMinimalListApiData,
    ServiceDepartmentMinimalListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-departments/minimal/', queryParams)
  }),
  getServiceDepartment: dataEndpoint<ServiceDepartmentGetApiData, ServiceDepartmentGetApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/`)
  }),
  postServiceDepartment: responseEndpoint<ServiceDepartmentCreateApiData, ServiceDepartmentCreateApiResponses>({
    getUrl: () => apiUrl('service-departments/'),
    getBody: (data) => data
  }),
  patchServiceDepartment: responseEndpoint<ServiceDepartmentPatchApiData, ServiceDepartmentPatchApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  deleteServiceDepartment: dataEndpoint<ServiceDepartmentDeleteApiData, ServiceDepartmentDeleteApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/`)
  }),
  getServiceDepartmentGroup: dataEndpoint<ServiceDepartmentGroupGetApiData, ServiceDepartmentGroupGetApiResponses>({
    getUrl: ({ serviceDepartmentGroupId }) => apiUrl(`service-department-groups/${serviceDepartmentGroupId}/`)
  }),
  postServiceDepartmentGroup: responseEndpoint<
    ServiceDepartmentGroupCreateApiData,
    ServiceDepartmentGroupCreateApiResponses
  >({
    getUrl: () => apiUrl('service-department-groups/'),
    getBody: (data) => data
  }),
  patchServiceDepartmentGroup: responseEndpoint<
    ServiceDepartmentGroupPatchApiData,
    ServiceDepartmentGroupPatchApiResponses
  >({
    getUrl: ({ serviceDepartmentGroupId }) => apiUrl(`service-department-groups/${serviceDepartmentGroupId}/`),
    getBody: ({ serviceDepartmentGroupId: _, ...body }) => body
  }),
  deleteServiceDepartmentGroup: dataEndpoint<
    ServiceDepartmentGroupDeleteApiData,
    ServiceDepartmentGroupDeleteApiResponses
  >({
    getUrl: ({ serviceDepartmentGroupId }) => apiUrl(`service-department-groups/${serviceDepartmentGroupId}/`)
  }),
  getServiceDepartmentGroupsForServiceOrganization: dataEndpoint<
    ServiceDepartmentGroupListByServiceOrganizationApiData,
    ServiceDepartmentGroupListByServiceOrganizationApiResponses
  >({
    getUrl: ({ serviceOrganizationId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/service-department-groups/`, queryParams)
  }),
  getServiceDepartmentMembers: dataEndpoint<
    ServiceDepartmentMemberListApiData,
    ServiceDepartmentMemberListApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/members/`, queryParams)
  }),
  getServiceDepartmentGroupMembers: dataEndpoint<
    ServiceDepartmentGroupMemberListApiData,
    ServiceDepartmentGroupMemberListApiResponses
  >({
    getUrl: ({ serviceDepartmentGroupId, ...queryParams }) =>
      apiUrl(`service-department-groups/${serviceDepartmentGroupId}/members/`, queryParams)
  }),
  postServiceDepartmentGroupAddMembers: responseEndpoint<
    ServiceDepartmentGroupAddMembersApiData,
    ServiceDepartmentGroupAddMembersApiResponses
  >({
    getUrl: ({ serviceDepartmentGroupId }) => apiUrl(`service-department-groups/${serviceDepartmentGroupId}/members/`),
    getBody: (data) => ({ userIds: data.userIds })
  }),
  getServiceDepartmentsOverview: dataEndpoint<
    ServiceDepartmentListCapacityOverviewApiData,
    ServiceDepartmentListCapacityOverviewApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-departments/capacity-overview/', queryParams)
  }),
  patchServiceDepartmentDeliveryAreas: responseEndpoint<
    ServiceDepartmentDeliveryAreasPatchApiData,
    ServiceDepartmentDeliveryAreasPatchApiResponses
  >({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/service-department-areas/`),
    getBody: (data) => data
  }),
  patchServiceDepartmentCapacity: responseEndpoint<
    ServiceDepartmentUpdateCapacityApiData,
    ServiceDepartmentUpdateCapacityApiResponses
  >({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/update-capacity/`),
    getBody: ({ serviceDepartmentId: _, ...body }) => body
  }),
  getServiceDepartmentDeliveryArea: dataEndpoint<
    ServiceDepartmentDeliveryAreaGetApiData,
    ServiceDepartmentDeliveryAreaGetApiResponses
  >({
    getUrl: ({ serviceDepartmentId, serviceAreaId }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/service-department-areas/${serviceAreaId}/`)
  }),
  getSuggestedServiceDepartmentAreas: dataEndpoint<
    ServiceDepartmentAreaSuggestionsApiData,
    ServiceDepartmentAreaSuggestionsApiResponses
  >({
    getUrl: ({ serviceWorkerAddressPairId, ...queryParams }) =>
      apiUrl(
        `service-worker-address-pairs/${serviceWorkerAddressPairId}/suggested-service-department-areas/`,
        queryParams
      )
  }),
  getPaginatedServiceOrganizations: dataEndpoint<ServiceOrganizationListApiData, ServiceOrganizationListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-organizations/', queryParams)
  }),
  getServiceOrganization: dataEndpoint<ServiceOrganizationGetApiData, ServiceOrganizationGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`service-organizations/${pk}/`)
  }),
  /** Public: name + address only, readable before the customer logs in. */
  getServiceOrganizationLocation: dataEndpoint<
    ServiceOrganizationLocationGetApiData,
    ServiceOrganizationLocationGetApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`service-organizations/${pk}/location/`)
  }),
  getServiceOrganizationAllowedBrands: dataEndpoint<
    ServiceOrganizationAllowedBrandsListApiData,
    ServiceOrganizationAllowedBrandsListApiResponses
  >({
    getUrl: ({ serviceOrganizationId }) => apiUrl(`service-organizations/${serviceOrganizationId}/allowed-brands/`)
  }),
  postServiceOrganization: responseEndpoint<ServiceOrganizationCreateApiData, ServiceOrganizationCreateApiResponses>({
    getUrl: () => apiUrl('service-organizations/'),
    getBody: (data) => data
  }),
  patchServiceOrganization: responseEndpoint<ServiceOrganizationUpdateApiData, ServiceOrganizationUpdateApiResponses>({
    getUrl: ({ pk }) => apiUrl(`service-organizations/${pk}/`),
    getBody: ({ pk: _id, ...patch }) => patch
  }),
  patchServiceOrganizationImage: responseEndpoint<
    ServiceOrganizationUpdateApiData,
    ServiceOrganizationUpdateApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`service-organizations/${pk}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: ({ pk: _, logo }) => {
      const formData = new FormData();
      if (logo) {
        formData.append('logo', logo);
      }
      return formData;
    },
    skipBodyTransformation: true
  }),
  deleteServiceOrganization: dataEndpoint<ServiceOrganizationDeleteApiData, ServiceOrganizationDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`service-organizations/${pk}/`)
  }),
  getServiceAreasForDeliveryMap: dataEndpoint<
    ServiceAreaListForDeliveryMapApiData,
    ServiceAreaListForDeliveryMapApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-areas/for-delivery-map/', queryParams)
  }),
  getPaginatedServiceAreas: dataEndpoint<ServiceAreaListApiData, ServiceAreaListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-areas/', queryParams)
  }),
  getServiceAreaMinimalList: dataEndpoint<ServiceAreaMinimalListApiData, ServiceAreaMinimalListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-areas/minimal/', queryParams)
  }),
  getServiceArea: dataEndpoint<ServiceAreaGetApiData, ServiceAreaGetApiResponses>({
    getUrl: ({ serviceAreaId }) => apiUrl(`service-areas/${serviceAreaId}/`)
  }),
  postServiceArea: responseEndpoint<ServiceAreaCreateApiData, ServiceAreaCreateApiResponses>({
    getUrl: () => apiUrl('service-areas/'),
    getBody: (data) => data
  }),
  patchServiceArea: responseEndpoint<ServiceAreaPatchApiData, ServiceAreaPatchApiResponses>({
    getUrl: ({ serviceAreaId }) => apiUrl(`service-areas/${serviceAreaId}/`),
    getBody: ({ serviceAreaId: _, ...body }) => body
  }),
  deleteServiceArea: dataEndpoint<ServiceAreaDeleteApiData, ServiceAreaDeleteApiResponses>({
    getUrl: ({ serviceAreaId }) => apiUrl(`service-areas/${serviceAreaId}/`)
  }),
  getServiceAreasForMapForServiceDepartment: dataEndpoint<
    ServiceDepartmentAreaListApiData,
    ServiceDepartmentAreaListApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/service-department-areas/`, queryParams)
  }),
  getServiceDepartmentGetStarted: dataEndpoint<
    ServiceDepartmentGetStartedApiData,
    ServiceDepartmentGetStartedApiResponses
  >({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/get-started/`)
  }),
  getServiceDepartmentAccessDepartments: dataEndpoint<
    UserServiceDepartmentAccessDepartmentsListApiData,
    UserServiceDepartmentAccessDepartmentsListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-department-access/departments/', queryParams)
  }),
  getServiceDepartmentAccessGroups: dataEndpoint<
    UserServiceDepartmentAccessGroupsListApiData,
    UserServiceDepartmentAccessGroupsListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-department-access/groups/', queryParams)
  }),
  getServiceWorkerContractAddresses: dataEndpoint<
    AddressForServiceWorkerContractListApiData,
    AddressForServiceWorkerContractListApiResponses
  >({
    getUrl: ({ serviceWorkerContractId }) => apiUrl(`service-worker-contracts/${serviceWorkerContractId}/addresses/`)
  }),
  getServiceDepartmentFromBookingSummary: dataEndpoint<
    ServiceDepartmentFromBookingParamsGetApiData,
    ServiceDepartmentFromBookingParamsGetApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-departments/from-booking-params/', queryParams)
  }),
  getServiceDepartmentFilterOptions: dataEndpoint<
    ServiceDepartmentFilterOptionsGetApiData,
    ServiceDepartmentFilterOptionsGetApiResponses
  >({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`service-departments/${serviceDepartmentId}/filter-options/`)
  }),
  getServiceOrganizationAdapters: dataEndpoint<
    ServiceOrganizationAdapterListApiData,
    ServiceOrganizationAdapterListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-organization-adapters/', queryParams)
  }),
  getDinteroSessionProfiles: dataEndpoint<DinteroSessionProfileListApiData, DinteroSessionProfileListApiResponses>({
    getUrl: ({ serviceOrganizationId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/dintero/session-profiles/`, queryParams)
  }),
  patchDinteroSessionProfile: responseEndpoint<
    DinteroSessionProfileUpdateApiData,
    DinteroSessionProfileUpdateApiResponses
  >({
    getUrl: ({ serviceOrganizationId, profileId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/dintero/session-profiles/${profileId}/`),
    getBody: ({ serviceOrganizationId: _serviceOrganizationId, profileId: _profileId, ...patch }) => patch
  }),
  postDinteroSessionProfile: responseEndpoint<
    DinteroSessionProfileCreateApiData,
    DinteroSessionProfileCreateApiResponses
  >({
    getUrl: ({ serviceOrganizationId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/dintero/session-profiles/`),
    getBody: ({ serviceOrganizationId: _serviceOrganizationId, ...body }) => body
  }),
  getDinteroSessionProfileCreateDefault: dataEndpoint<
    DinteroSessionProfileCreateDefaultApiData,
    DinteroSessionProfileCreateDefaultApiResponses
  >({
    getUrl: ({ serviceOrganizationId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/dintero/session-profiles/create-default/`, queryParams)
  }),
  postServiceOrganizationStripeOnboardingLink: responseEndpoint<
    ServiceOrganizationStripeOnboardingLinkApiData,
    ServiceOrganizationStripeOnboardingLinkApiResponses
  >({
    getUrl: ({ serviceOrganizationId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/stripe/onboarding-link/`),
    getBody: ({ serviceOrganizationId: _serviceOrganizationId, ...body }) => body
  }),
  getServiceOrganizationStripeAccountStatus: dataEndpoint<
    ServiceOrganizationStripeAccountStatusApiData,
    ServiceOrganizationStripeAccountStatusApiResponses
  >({
    getUrl: ({ serviceOrganizationId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/stripe/account-status/`, queryParams)
  }),
  getServiceDepartmentPaymentDefaults: dataEndpoint<
    ServiceDepartmentPaymentDefaultsApiData,
    ServiceDepartmentPaymentDefaultsApiResponses
  >({
    getUrl: () => apiUrl('service-departments/payment-defaults/')
  })
};
